module.exports = __webpack_public_path__ + "static/img/caichan.d2b6f84e.png";